import React, { memo, useCallback } from 'react';
import { format, isValid } from 'date-fns';
import { DayPicker } from 'react-day-picker';
import { DayContent } from './DayContent';
import { DEFAULT_DATE_FORMAT } from './constants';
import { DatePickerMode } from './types';
export const SingleCalendar = memo(({ date, disabledDays, onChange, toggleCalendar, setInputValue, CaptionComponent, isRequired = false, }) => {
    const handleOnSelectDate = useCallback((dateValue) => {
        const nextInputValue = isValid(dateValue)
            ? format(dateValue, DEFAULT_DATE_FORMAT)
            : '';
        onChange(dateValue);
        setInputValue(nextInputValue);
        toggleCalendar();
    }, [onChange, setInputValue, toggleCalendar]);
    return (React.createElement(DayPicker, { disabled: disabledDays, mode: DatePickerMode.SINGLE, defaultMonth: date, selected: date, onSelect: handleOnSelectDate, components: {
            Caption: CaptionComponent,
            DayContent,
        }, required: isRequired }));
});
SingleCalendar.displayName = 'SingleCalendar';
